import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";
import useSWR from "swr";
import { firebaseApp } from "../../../firebase/firebaseClient";
import { PrepFqQuestion } from "../../../models/prepFqQuiz";
import { PrepFqAnswer } from "../../../models/users";

const fetcher = async (url: string, answersToFetch: string) => {
  if (url) {
    const splits = url.split(`/prep_fq_profiles/answers/`);
    const profileId = splits[1];
    const answersToFetchArray = answersToFetch.split(",");
    if (!answersToFetch || answersToFetchArray.length === 0) {
      return [];
    } else {
      const firestore = getFirestore(firebaseApp);
      const answerRef = query(
        collection(firestore, "prep_fq_profiles", profileId, "answers"),
        where("question_id", "in", answersToFetchArray)
      );
      const answersSnaps = await getDocs(answerRef);
      const answers: PrepFqAnswer[] = answersSnaps.docs.map((doc) => {
        return doc.data() as PrepFqAnswer;
      });
      return answers;
    }
  } else {
    return undefined;
  }
};

function usePrepFqAnswers(profileId?: string, questions?: PrepFqQuestion[]) {
  const answersToFetch: string = questions
    ?.map((question) => {
      return question.question_id;
    })
    ?.toString();
  const { data, mutate, isValidating, error } = useSWR(
    [
      profileId && answersToFetch
        ? `/prep_fq_profiles/answers/${profileId}`
        : null,
      answersToFetch,
    ],
    fetcher,
    { revalidateOnFocus: false }
  );
  const result: {
    answers: PrepFqAnswer[];
    isLoading: boolean;
    isValidating: boolean;
    isError: boolean;
    mutate: any;
  } = {
    answers: data as any,
    isLoading: !error && !data,
    isValidating,
    isError: error,
    mutate,
  };
  return result;
}

export default usePrepFqAnswers;
